const React = require("react");

function ReplyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
  }));
}

module.exports = ReplyIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ReplyIcon.js
 ** module id = 597
 ** module chunks = 0
 **/